import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaDocument = yup.object().shape({
  title: yup
    .string()
    .required(translate('modelsDocumentsCreateEdit.validation.titleRequired')),
  text_description: yup.string(),
});
